<template>
	<div class="bindgoods">
		<div style="width: 800px;margin-top: 1.25rem;">
			<span class="shop-choose">shopId:</span>
			<el-select @change="getShopItems(value)" v-model="value" :placeholder="$t('other.a50')" style="margin-left: 10px;">
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-button class="save-bind" type="primary" style="float:right">{{$t('other.a1077')}}</el-button>
		</div>
		<div>
			<template style="height: 500px;">
				<p style="text-align: center; margin: 0 0 20px">{{$t('other.a1078')}}</p>
				<el-transfer filterable  style="text-align: left; display: inline-block;" :titles="[$t('other.a1079'), $t('other.a1080')]" :button-texts="[$t('other.a312'), $t('other.a1081')]"
				 v-model="ischooseList" :data="goodslist">
				</el-transfer>
			</template>
		</div>
	</div>
</template>

<script>
	import api from '../../api/api.js'
	import {
		mapState,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				options: [{
					value: '235415214',
					label: '235415214'
				}, {
					value: '255184744',
					label: '255184744'
				}, {
					value: '286652887',
					label: '286652887'
				}],
				value: '',
				ischooseList: [],
				count: 0,
				arr: [],

			}
		},
		components: {

		},
		computed: {
			...mapState({
				goodslist: state => state.bindgood.goodslist
			}),
		},
		methods: {
			...mapActions('bindgood', ['getShopAllItems']),
			getShopItems(value) {
				this.getShopAllItems(value)
			},
			handleBtn() {
				console.log(this.goodslist)
			},
			getTime(time) {
				let ttp = time.slice(0, time.indexOf('T'))
				let ccp = time.slice(time.indexOf('T') + 1, time.indexOf('.'))
				return ttp + ' ' + ccp

			},
			//状态转换
			conversionStatus(ttp) {
				const status = {
					NORMAL: this.$t('other.a1082'),
					UNLIST: this.$t('other.a1083')
				}
				return status[ttp]
			}

		}

	}
</script>

<style>
	/* .bindgoods {
		
		flex: 1;
		margin: 60px 0 0 235px;
	} */

	.el-transfer-panel {
		width: 450px;
		height: 450px;
	}

	.el-checkbox-group  {
		height: 500px !important;
	}

	.shopId {
		display: flex;
		justify-content: space-between;
		margin: 10px;
		padding: 10px;
		border-bottom: 1px #E0E0E0 solid;
	}

	.el-transfer__buttons {
		writing-mode:vertical-lr
	}
	.save-bind{
		
		
	}
	.el-checkbox-group{
		
	}
	
</style>
